import { FetchError } from "@medusajs/js-sdk";
// Re-export withMeta from framework for backward compatibility
export { getHandlingTimeLabel, withMeta } from "@salonstocker/framework";

export function isFetchError(error: unknown): error is FetchError {
  return error instanceof FetchError;
}
